import React from "react";

interface HomePageProps {
  onNavigate: (page: string) => void;
}

const HomePage: React.FC<HomePageProps> = ({ onNavigate }) => {
  const handleCardClick = (page: string) => {
    onNavigate(page);
  };

  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-8 border border-indigo-100">
          <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-8 py-8 text-white">
            <h1 className="text-3xl font-bold mb-1">One tool to rule them all.</h1>
            <p className="text-indigo-100 text-base">OpsNest connects your repos, deployments, sprint tickets, and config in one place so you spend less time hunting across tools and more time shipping.</p>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              {/* Release Management */}
              <div
                onClick={() => handleCardClick("GitHub")}
                className="bg-gray-50 rounded-lg p-5 border border-gray-100 hover:bg-gray-100 transition-colors duration-200 cursor-pointer hover:shadow"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-white rounded-lg p-2 flex-shrink-0 border border-gray-100">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.82m5.84-2.56a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.82m2.56-5.84a14.98 14.98 0 00-2.58 5.84m2.56-5.84a14.98 14.98 0 015.84-2.56" />
                    </svg>
                  </div>
                  <h2 className="text-base font-semibold text-gray-800">Release Management</h2>
                </div>
                <p className="text-gray-500 text-sm mb-3">Track release status and promote code across environments.</p>
                <ul className="space-y-1.5">
                  <li className="flex items-center gap-2 text-sm text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Plan and execute promotions
                  </li>
                  <li className="flex items-center gap-2 text-sm text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Track Jira fix versions
                  </li>
                </ul>
              </div>
              {/* Azure Monitoring Card */}
              {/* <div 
                onClick={() => handleCardClick("AzureMonitoring")}
                className="bg-purple-50 rounded-lg p-4 border border-purple-100 hover:bg-purple-100 transition-colors duration-200 cursor-pointer hover:shadow flex items-center space-x-3"
              >
                <div className="bg-purple-100 rounded-lg p-2 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Azure</h2>
                  <p className="text-gray-600 text-sm">View analytics about your Azure resources.</p>
                </div>
              </div> */}
              {/* Domains Monitoring Card */}
              {/* <div 
                onClick={() => handleCardClick("DomainsMonitoring")}
                className="bg-emerald-50 rounded-lg p-4 border border-emerald-100 hover:bg-emerald-100 transition-colors duration-200 cursor-pointer hover:shadow flex items-center space-x-3"
              >
                <div className="bg-emerald-100 rounded-lg p-2 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-emerald-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16a7 7 0 110-14 7 7 0 010 14zm0-12a5 5 0 100 10A5 5 0 0012 7zm0 8a3 3 0 110-6 3 3 0 010 6z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Domains</h2>
                  <p className="text-gray-600 text-sm">Monitor and manage your registered domains.</p>
                </div>
              </div> */}
              {/* Maintenance Card */}
              {/* <div 
                onClick={() => handleCardClick("Maintenance")}
                className="bg-red-50 rounded-lg p-4 border border-red-100 hover:bg-red-100 transition-colors duration-200 cursor-pointer hover:shadow flex items-center space-x-3"
              >
                <div className="bg-red-100 rounded-lg p-2 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-red-700" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v-.07zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Maintenance</h2>
                  <p className="text-gray-600 text-sm">Perform critical maintenance operations with caution.</p>
                </div>
              </div> */}
              {/* Config Store */}
                <div
                  onClick={() => handleCardClick("ConfigStore")}
                  className="bg-amber-50 rounded-lg p-5 border border-amber-100 hover:bg-amber-100 transition-colors duration-200 cursor-pointer hover:shadow"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="bg-white rounded-lg p-2 flex-shrink-0 border border-amber-100">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-amber-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <h2 className="text-base font-semibold text-gray-800">Config Management</h2>
                  </div>
                  <p className="text-gray-500 text-sm mb-3">Submit and approve App Configuration values across environments.</p>
                  <ul className="space-y-1.5">
                    <li className="flex items-center gap-2 text-sm text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-amber-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Submit key-value pairs or key vault references
                    </li>
                    <li className="flex items-center gap-2 text-sm text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-amber-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Admin approval for production
                    </li>
                  </ul>
                </div>
              {/* ArgoCD Deployments */}
                <div
                  onClick={() => handleCardClick("ArgoCD")}
                  className="bg-indigo-50 rounded-lg p-5 border border-indigo-100 hover:bg-indigo-100 transition-colors duration-200 cursor-pointer hover:shadow"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="bg-white rounded-lg p-2 flex-shrink-0 border border-indigo-100">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 10l-8-4V7" />
                      </svg>
                    </div>
                    <h2 className="text-base font-semibold text-gray-800">Kubernetes Deployments</h2>
                  </div>
                  <p className="text-gray-500 text-sm mb-3">View AKS deployment status and application health across environments.</p>
                  <ul className="space-y-1.5">
                    <li className="flex items-center gap-2 text-sm text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Dev, staging and production clusters
                    </li>
                    <li className="flex items-center gap-2 text-sm text-gray-500">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Direct links to ArgoCD dashboards
                    </li>
                  </ul>
                </div>
            </div>
            {/* <div className="flex justify-center">
              <button 
                onClick={() => handleCardClick("GitHub")}
                className="px-6 py-2 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-medium rounded-md shadow-md hover:from-indigo-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 text-base"
              >
                Get Started
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;